import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './_images/cover.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-9fc7d482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vip-modify-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cover-img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-header" }, "新版来袭！会员模式升级啦～", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-item",
  style: {"margin-top":"40px"}
}, "新版本已取消会员等级采购方式，升级为根据企业办公需要，自主搭配选择所需的功能进行订阅。", -1))
const _hoisted_5 = {
  class: "text-item",
  style: {"margin-top":"10px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "免费开放所有需付费的服务直至原订单有效期止，并赠送9999台终端配置额度", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-item",
  style: {"margin-top":"40px","font-size":"14px"}
}, "如有疑问或建议，请联系客服186-8811-5347、186-7086-0265。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    "custom-class": "vip-modify-wrap-custom",
    "modal-class": "cm-notify-popup-modal",
    "close-on-click-modal": false,
    "destroy-on-close": "",
    width: 550
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createTextVNode("为感谢您作为资深客户的支持，我们向您"),
          _hoisted_6,
          _createTextVNode("。您可前往"),
          _createElementVNode("span", {
            class: "cm-link-light underline",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toMyService && _ctx.toMyService(...args)))
          }, "【我的服务】"),
          _createTextVNode("进行体验~ ")
        ]),
        _hoisted_7,
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100%"},
          size: "large",
          onClick: _ctx.doKnow
        }, {
          default: _withCtx(() => [
            _createTextVNode("我知道了")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}